import { useEffect, useState } from 'react';
import { Box, Typography, Container, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import React from "react";
import Comp1Sub from "./Comp1Sub";
import Comp2Sub from "./Comp2Sub";
import axios from "axios";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from './api';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import HamburgerMenu from './components/Hamburger';

const FormRequire = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors, exhibitors}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sameAsExhibitor1, setSameAsExhibitor1] = useState("different");
  const [sameAsExhibitor2, setSameAsExhibitor2] = useState("different");
  const [sameAsCertExhibitor, setSameAsCertExhibitor] = useState("different");
  const [sameAsCertExhibitor2, setSameAsCertExhibitor2] = useState("different");

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

  const [comp1Data, setComp1Data] = useState({
    manager_name: "",
    manager_department: "",
    manager_phone: "",
    manager_tel: "",

    user_1_name: "",
    user_1_department: "",
    user_1_phone: "",
    user_1_tel: "",

    pledge: true,
    panel_pledge: false,
    panel_question: "",
    panel_plan: "",
          catchphrase: "キャッチコピー",
          booth_change_detail: "ブース変更内容",

    package_company_name: "",
    package_company_tel: "",
    package_phone_number: "",
    package_company_address: "",
    package_company_zip: "",
    package_company_fax: "",
    package_name: "",

    elec_company_name: "",
    elec_company_tel: "",
    elec_phone_number: "",
    elec_company_address: "",
    elec_company_zip: "",
    elec_company_fax: "",
    elec_name: "",

    infla_company_name: "",
    infla_company_tel: "",
    infla_phone_number: "",
    infla_company_address: "",
    infla_company_zip: "",
    infla_company_fax: "",
    infla_name: "",

    cargo_company_name: "",
    cargo_company_tel: "",
    cargo_phone_number: "",
    cargo_company_address: "",
    cargo_company_zip: "",
    cargo_company_fax: "",
    cargo_name: "",

    alfa_text: ""
  });

  const [comp2Data, setComp2Data] = useState({
    // Comp2 初期値
    user_2_name: "",
    user_2_department: "",
    user_2_phone: "",
    user_2_tel: "",
    method: "",
    reserve_date: "",
    reserve_detail: "",
    car_certification: false,
    indoor_car: false,
    other_detail: '',
    alfa_text: "",
    catchphrase: "",
    details: [
      {
        exhibition: "",
        number: 0,
        weight: 0,
        length: 0,
        width: 0,
        height: 0,
      },
    ],
    cert_details: [],
    indoor_details: [],
  });

  const [otherMethod, setOtherMethod] = useState('');

  const [detailErrors, setDetailErrors] = useState([
    { number: "", weight: "", length: "", width: "", height: "" },
  ]);

  const [corrections, setCorrections] = useState({
      r1: [{
        manager_info: false,  
        user_1_info: false,
        water_info: false,
        package_info: false,
        elec_info: false,
        cargo_info: false,
      }],
      r2: [{
        user_2_info: false,
        method: false,
        date: false,
        cars: false,
        numbers: false,
        exhibits: false,
      }],
  });

  const field_name_map = {
    manager_info: "責任者情報",
    user_1_info: "担当者情報",
    water_info: "水関連情報",
    package_info: "梱包情報",
    elec_info: "電気情報",
    cargo_info: "荷物情報",
    user_2_info: "担当者情報2",
    method: "搬入方法",
    date: "搬入日",
    cars: "車両情報",
    numbers: "台数",
    exhibits: "出展物"
  };

  const [memoText, setMemoText] = useState('');

  const handleCorrectionChange = (groupKey, fieldKey) => (e) => {
      setCorrections(prev => ({
        ...prev,
        [groupKey]: [
          {
            ...prev[groupKey][0],
            [fieldKey]: e.target.checked
          }
        ]
      }));
    };

  const updateStatus = (exhibitorId, formType, updates) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              ...Object.fromEntries(
                Object.entries(updates).map(([role, status]) => [
                  `${formType}_${role}_status`,
                  status,
                ])
              ),
            }
          : ex
      )
    );
  };

  const handleMethodChange = (event) => {
    const newValue = event.target.value;

    // 現在「その他」が選択されていて、
    // 入力済みの状態で他を選ぼうとした場合
    if (
      comp2Data.method.startsWith('その他｜') &&
      otherMethod.trim() !== '' &&
      newValue !== 'その他'
    ) {
      const ok = window.confirm(
        'その他の入力欄の内容は破棄されますがよろしいですか？'
      );

      if (!ok) {
        return;
      }

      setOtherMethod('');
    }

    // その他選択時
    if (newValue === 'その他') {
      setComp2Data(prev => ({
        ...prev,
        method: otherMethod
          ? `その他｜${otherMethod}`
          : 'その他｜'
      }));
    } else {
      setComp2Data(prev => ({
        ...prev,
        method: newValue
      }));
    }
  };

  const handleOtherMethodChange = (event) => {
    const value = event.target.value;

    setOtherMethod(value);

    setComp2Data(prev => ({
      ...prev,
      method: `その他｜${value}`
    }));
  };

    const handleCorrection = async () => {
      try {
        // 選択された修正項目を日本語に変換して抽出
        const selectedFields = Object.entries(corrections).flatMap(([_, items]) =>
          Object.entries(items[0])
            .filter(([_, checked]) => checked)
            .map(([field]) => field_name_map[field] || field)
        );

        if (selectedFields.length === 0) {
          alert('修正対象の項目を選択してください');
          return;
        }

        const currentPath = window.location.pathname;

        await api.patch('/api/host-correction', {
          exhibitor_id: exhibitorId,
          form_type: selectedFormKey,
          correction: selectedFields,
          memo: memoText,
          current_path: currentPath,
        });

        // 👇 これ追加
        updateStatus(exhibitorId, 'r1', {
          host: '未確認',
          corporate: '未確認',
        });

        alert('修正リクエスト送信完了');
        setFormModalOpen(false);

        // UIリセット
        setCorrections({
          r1: [Object.fromEntries(Object.keys(corrections.r1[0]).map(k => [k, false]))],
          r2: [Object.fromEntries(Object.keys(corrections.r2[0]).map(k => [k, false]))],
        });
        setMemoText('');

      } catch (err) {
        console.error(err);
        alert('修正処理でエラーが発生しました');
      }
    };

    const updateHostStatus = (exhibitorId, formType, newStatus) => {
      setExhibitors((prev) =>
        prev.map((ex) =>
          ex.exhibitor_id === exhibitorId
            ? {
                ...ex,
                [`${formType}_host_status`]: newStatus,
                [`${formType}_corporate_status`]: newStatus, // ←これ追加
              }
            : ex
        )
      );
    };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });

      updateHostStatus(exhibitorId, selectedFormKey,'確認済');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "host"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );

  const [fieldsDisabled1, setFieldsDisabled1] = useState(false);
  const [fieldsDisabled2, setFieldsDisabled2] = useState(false);
  const [fieldsCertDisabled, setFieldsCertDisabled] = useState(false);
  const [fieldsCertDisabled2, setFieldsCertDisabled2] = useState(false);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // --- localStorageから古いuser_idを削除 ---
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (storedUser && storedUser.user_id === 0) {
          console.warn("キャッシュされたuser_id=0を削除します");
          delete storedUser.user_id;
          localStorage.setItem("user", JSON.stringify(storedUser));
        }
        
        // --- 正常なユーザー情報を使用して残りの初期処理 ---
        const [resRequire, resMypage] = await Promise.all([
          api.get(`/api/forms/require_data/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`),
        ]);

        const r1 = resRequire.data.r1 || {};
        const r2Raw = resRequire.data.r2 || {};
        const mypage = resMypage.data || {};

        // detailsの初期補完
        const safeR2 = {
          ...r2Raw,
          details: Array.isArray(r2Raw.details)
            ? r2Raw.details
            : [
                {
                  exhibition: "",
                  number: 0,
                  weight: 0,
                  length: 0,
                  width: 0,
                  height: 0,
                },
              ],
          cert_details: Array.isArray(r2Raw.cert_details)
            ? r2Raw.cert_details
            : [],
          indoor_details: Array.isArray(r2Raw.indoor_details)
            ? r2Raw.indoor_details
            : []

        };

        if (
          typeof safeR2.method === 'string' &&
          safeR2.method.startsWith('その他｜')
        ) {
          setOtherMethod(
            safeR2.method.slice('その他｜'.length)
          );
        }

        // comp1Data設定
        if (Object.values(r1).some(v => v !== "" && v !== null && v !== undefined)) {
          setComp1Data({
            ...r1,
            has_package_company: !!r1?.package_company_name,
            has_elec_company: !!r1?.elec_company_name,
            has_infla_company: !!r1?.infla_company_name,
            has_cargo_company: !!r1?.cargo_company_name,
          });
        }

        // comp2Data設定
        if (
          Object.values(r2Raw).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
          })
        ) {
          setComp2Data(prev => ({
            ...prev,
            ...safeR2,
          }));
        }

        setMypageData(mypage);

        // --- same判定 ---
        if (
          r1.user_1_name === mypage.user_name &&
          r1.user_1_department === mypage.department &&
          r1.user_1_phone === mypage.phone_number &&
          r1.user_1_tel === mypage.tel_number
        ) {
          setSameAsExhibitor1("same");
          setFieldsDisabled1(true);
        } else {
          setFieldsDisabled1(false);
        }

        if (
          safeR2.user_2_name === mypage.user_name &&
          safeR2.user_2_department === mypage.department &&
          safeR2.user_2_phone === mypage.phone_number &&
          safeR2.user_2_tel === mypage.tel_number
        ) {
          setSameAsExhibitor2("same");
          setFieldsDisabled2(true);
        } else {
          setFieldsDisabled2(false);
        }
        const certSame =
        safeR2.cert_details?.length > 0 &&
        safeR2.cert_details.every(
        (item)=>
        item.cert_comp === mypage.company_name &&
        item.cert_user === mypage.user_name &&
        item.cert_phone === mypage.phone_number
        );
        if(certSame){
        setSameAsCertExhibitor("same");
        setFieldsCertDisabled(true);
        }else{
        setFieldsCertDisabled(false);
        }
        const indoorSame =
        safeR2.indoor_details?.length > 0 &&
        safeR2.indoor_details.every(
        (item)=>
        item.cert_comp === mypage.company_name &&
        item.cert_user === mypage.user_name &&
        item.cert_phone === mypage.phone_number
        );


        if(indoorSame){
        setSameAsCertExhibitor2("same");
        setFieldsCertDisabled2(true);
        }else{
        setFieldsCertDisabled2(false);
        }
      } catch (err) {
        console.error("初期データ取得エラー:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [exhibitorId]);

  const [ submitErrors1, setSubmitErrors1] = useState({});
  const [ submitErrors2, setSubmitErrors2] = useState({});
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const downloadFile = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadBlobFile = (blob, filename) => {
    const blobUrl = window.URL.createObjectURL(blob);
    downloadFile(blobUrl, filename);
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
  };

  const finalizeAfterSubmit = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else if (mypageData?.user_id === 0) {
        navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
      } else {
        navigate(`/mypage/${user?.mypage_id}`);
      }
    }, 300);
  };

  const extractFilename = (contentDisposition) => {
    if (!contentDisposition) return null;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      return decodeURIComponent(utf8Match[1]);
    }

    const asciiMatch = contentDisposition.match(/filename=\"?([^\";]+)\"?/i);
    return asciiMatch?.[1] || null;
  };

  const handleDownloadCertificates = async () => {
    try {
      setDownloadLoading(true);
      const res = await api.post(
        "/api/r2-certificate-download",
        { exhibitor_id: exhibitorId },
        { responseType: "blob" }
      );

      const filename =
        extractFilename(res.headers?.["content-disposition"]) ||
        "r2-certificates.zip";

      downloadBlobFile(res.data, filename);
      setDownloadModalOpen(false);
      alert("証票ファイルをダウンロードしました");
      finalizeAfterSubmit();
    } catch (err) {
      console.error(err);
      alert("証票ファイルの作成に失敗しました");
    } finally {
      setDownloadLoading(false);
    }
  };
  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        console.error("exhibitorId が不正やで:", exhibitorId);
        alert("exhibitorId が不正です");
        return;
      }

      const user = JSON.parse(localStorage.getItem("user"));
      // -------------------------
      // submitErrors1: R1 必須入力
      // -------------------------
      const submitErrors1 = {};

      if (!comp1Data.manager_name?.trim()) submitErrors1.manager_name = "入力してください";
      if (!comp1Data.manager_department?.trim()) submitErrors1.manager_department = "入力してください";
      if (!comp1Data.manager_phone?.trim()) submitErrors1.manager_phone = "入力してください";
      if (!comp1Data.manager_tel?.trim()) submitErrors1.manager_tel = "入力してください";
      if (!comp1Data.user_1_name?.trim()) submitErrors1.user_1_name = "入力してください";
      if (!comp1Data.user_1_department?.trim()) submitErrors1.user_1_department = "入力してください";
      if (!comp1Data.user_1_phone?.trim()) submitErrors1.user_1_phone = "入力してください";
      if (!comp1Data.user_1_tel?.trim()) submitErrors1.user_1_tel = "入力してください";
      if (!comp1Data.pledge) submitErrors1.pledge = "チェックしてください";

      if (comp1Data.has_package_company) {
        ["package_company_name","package_company_tel","package_phone_number","package_company_zip","package_company_address","package_name"]
          .forEach(field => {
            if (!comp1Data[field]?.trim()) submitErrors1[field] = "入力してください";
          });
      }
      if (comp1Data.has_elec_company) {
        ["elec_company_name","elec_company_tel","elec_phone_number","elec_company_zip","elec_company_address","elec_name"]
          .forEach(field => {
            if (!comp1Data[field]?.trim()) submitErrors1[field] = "入力してください";
          });
      }
      if (comp1Data.has_infla_company) {
        ["infla_company_name","infla_company_tel","infla_phone_number","infla_company_zip","infla_company_address","infla_name"]
          .forEach(field => {
            if (!comp1Data[field]?.trim()) submitErrors1[field] = "入力してください";
          });
      }
      if (comp1Data.has_cargo_company) {
        ["cargo_company_name","cargo_company_tel","cargo_phone_number","cargo_company_zip","cargo_company_address","cargo_name"]
          .forEach(field => {
            if (!comp1Data[field]?.trim()) submitErrors1[field] = "入力してください";
          });
      }

      if (user.user_id === 0) {
        if (!comp1Data.panel_plan?.trim()) {
          submitErrors1.panel_plan = "選択してください";
        }
      }

      // -------------------------
      // submitErrors2: Comp2Sub 必須入力
      // -------------------------
      const submitErrors2 = {};

      if (!comp2Data.user_2_name?.trim()) submitErrors2.user_2_name = "入力してください";
      if (!comp2Data.user_2_department?.trim()) submitErrors2.user_2_department = "入力してください";
      if (!comp2Data.user_2_phone?.trim()) submitErrors2.user_2_phone = "入力してください";
      if (!comp2Data.user_2_tel?.trim()) submitErrors2.user_2_tel = "入力してください";

      if (!comp2Data.reserve_date?.trim()) submitErrors2.reserve_date = "入力してください";
      if (comp2Data.car_certification !== true && comp2Data.car_certification !== false) {
        submitErrors2.car_certification = "搬入出車両証を選択してください";
      }
      if (comp2Data.indoor_car !== true && comp2Data.indoor_car !== false) {
        submitErrors2.indoor_car = "展示館内への車両乗入れを選択してください";
      }

      const hasExhibitDetailContent = (detail) => {
        if (!detail) return false;
        if (detail.exhibition?.trim()) return true;
        return [detail.number, detail.weight, detail.length, detail.width, detail.height].some((value) => Number(value) > 0);
      };

      const validateVehicleDetails = (details, errorKey) => {
        let hasVehicleError = false;

        details.forEach((item, index) => {
          if (!item?.cert_comp?.trim()) {
            submitErrors2[`${errorKey}_${index}_cert_comp`] = "入力してください";
            hasVehicleError = true;
          }
          if (!item?.cert_user?.trim()) {
            submitErrors2[`${errorKey}_${index}_cert_user`] = "入力してください";
            hasVehicleError = true;
          }
          if (!item?.cert_phone?.trim()) {
            submitErrors2[`${errorKey}_${index}_cert_phone`] = "入力してください";
            hasVehicleError = true;
          }
        });

        if (hasVehicleError) {
          submitErrors2[errorKey] = "各車両の会社名・氏名・電話番号を入力してください";
        }
      };

      if (comp2Data.car_certification) {
        if (!Array.isArray(comp2Data.cert_details) || comp2Data.cert_details.length === 0) {
          submitErrors2.car_certification = "車両台数を入力してください";
        } else {
          validateVehicleDetails(comp2Data.cert_details, "cert_details");
        }
      }

      // -------------------------
      // エラー表示
      // -------------------------

      const allErrors = { ...submitErrors1, ...submitErrors2 };
      if (Object.keys(allErrors).length > 0) {
        setSubmitErrors1(submitErrors1);
        setSubmitErrors2(submitErrors2);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const fieldDisplayNames = {
          manager_name: "管理者名",
          manager_department: "管理部署",
          manager_phone: "管理者携帯",
          manager_tel: "管理者電話",
          user_1_name: "担当者名",
          user_1_department: "担当部署",
          user_1_phone: "担当者携帯",
          user_1_tel: "担当者電話",
          pledge: "誓約チェック",
          elec_company_name: "電気工事委託　会社名",
          elec_company_tel: "電気工事委託　会社電話番号",
          elec_phone_number: "電気工事委託　携帯電話番号",
          elec_company_zip: "電気工事委託　郵便番号",
          elec_company_address: "電気工事委託　住所",
          elec_name: "電気工事委託　担当者名",
          package_company_name: "装飾委託　会社名",
          package_company_tel: "装飾委託　会社電話番号",
          package_phone_number: "装飾委託　携帯電話番号",
          package_company_zip: "装飾委託　郵便番号",
          package_company_address: "装飾委託　住所",
          package_name: "装飾委託　担当者名",
          infla_company_name: "給排水・エア・ガス工事委託　会社名",
          infla_company_tel: "給排水・エア・ガス工事委託　会社電話番号",
          infla_phone_number: "給排水・エア・ガス工事委託　携帯電話番号",
          infla_company_zip: "給排水・エア・ガス工事委託　郵便番号",
          infla_company_address: "給排水・エア・ガス工事委託　住所",
          infla_name: "給排水・エア・ガス工事委託　担当者名",
          cargo_company_name: "荷役委託　会社名",
          cargo_company_tel: "荷役委託　会社電話番号",
          cargo_phone_number: "荷役委託　携帯電話番号",
          cargo_company_zip: "荷役委託　郵便番号",
          cargo_company_address: "荷役委託　住所",
          cargo_name: "荷役委託　担当者名",
          user_2_name: "担当者名",
          user_2_department: "担当部署",
          user_2_phone: "担当者携帯",
          user_2_tel: "担当者電話",
          method: "申請方法",
          reserve_date: "搬入予定日",
          car_certification: "搬入出車両証",
          cert_details: "搬入出車両証の運転者情報",
          indoor_car: "展示館内乗入れ",
          indoor_details: "展示館内乗入れの運転者情報",
          other_detail: "その他台数詳細",
          details: "出展物詳細",
          panel_plan: "社名板表記方法",
        };

        const visibleErrors = Object.entries(allErrors).filter(
          ([key]) => !key.startsWith("cert_details_") && !key.startsWith("indoor_details_")
        );

        const errorMessages = visibleErrors
          .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const sanitizeR2 = (raw) => ({
        ...raw,
        method: raw.method?.trim() ? raw.method : "車両情報入力",
        details: (Array.isArray(raw.details) ? raw.details : [])
          .filter(hasExhibitDetailContent)
          .map((item) => ({
            ...item,
            exhibition: item.exhibition?.trim() || "",
            number: Number(item.number),
            weight: Number(item.weight),
            length: Number(item.length),
            width: Number(item.width),
            height: Number(item.height),
          })),
        cert_details: (Array.isArray(raw.cert_details) ? raw.cert_details : []).map((item) => ({
          car_kind: item.car_kind,
          cert_comp: item.cert_comp?.trim() || "",
          cert_user: item.cert_user?.trim() || "",
          cert_phone: item.cert_phone?.trim() || "",
        })),
        indoor_details: (Array.isArray(raw.indoor_details) ? raw.indoor_details : []).map((item) => ({
          car_kind: item.car_kind,
          cert_comp: item.cert_comp?.trim() || "",
          cert_user: item.cert_user?.trim() || "",
          cert_phone: item.cert_phone?.trim() || "",
        })),
      });
      const payload = {
        exhibitor_id: exhibitorId,
        r1: comp1Data,
        r2: sanitizeR2(comp2Data),
      };
      delete payload.has_package_company;
      delete payload.has_elec_company;
      delete payload.has_infla_company;
      delete payload.has_cargo_company;

      let endpoint = "/api/require_submit";
      if (mypageData?.user_id === 0 && mypageData?.parent_exhibit === false) {
        endpoint = "/api/require_parent";
      }

      Object.entries(comp1Data).forEach(([k,v])=>{
        if (v === "NaN" || Number.isNaN(v)) {
          console.warn("NaN検出:", k, v);
        }
      });

      const res = await api.post(endpoint, payload);

      if (res.status === 200) {
        if (comp2Data.car_certification || comp2Data.indoor_car) {
          setDownloadModalOpen(true);
          return;
        }
        alert("保存成功");
        finalizeAfterSubmit();
      } else {
        alert("保存失敗");
      }
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

   if (loading) return <div>読み込み中...</div>;

  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="しんきんビジネスマッチング　ビジネスフェア2026 必須申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }} className='sm-block'>
        {!isCorpModal &&(
        <>  
        <Container sx={{ width: '22%', mt: 4 }} className='sm-none'>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Typography variant="h6" gutterBottom>
              修正内容のメモ
            </Typography>
            <TextField
              multiline
              rows={20}
              fullWidth
              placeholder="ここに修正内容を書いてください..."
              value={memoText}
              onChange={(e) => setMemoText(e.target.value)}
            />
            <Box>
              <Typography variant="h6" className='f-16'>マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
            <Box sx={{p:2}} className="sm-none">
              <Typography variant="h6" className='f-16'>マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', margin: 'auto'}} className='f-16'>出展責任者登録</Typography>
            <Container sx={{width: '95%', margin: 'auto', border: '1px solid #000', borderRadius: '12px'}}>
                <Comp1Sub formData={comp1Data} setFormData={setComp1Data} corrections={corrections} setCorrections={setCorrections} handleCorrectionChange={handleCorrectionChange} changeModalOpen={changeModalOpen} mypageData={mypageData} sameAsExhibitor={sameAsExhibitor1} setSameAsExhibitor={setSameAsExhibitor1} fieldsDisabled={fieldsDisabled1} setFieldsDisabled={setFieldsDisabled1} submitErrors={submitErrors1} exhibitorId={exhibitorId} exhibitors={exhibitors} />
            </Container>

            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', mx: 'auto', my: 4}} className='f-16'>搬入・搬出計画登録</Typography>
            <Container sx={{width: '95%', margin: 'auto', border: '1px solid #000', borderRadius: '12px'}}>
                <Comp2Sub formData={comp2Data} setFormData={setComp2Data} corrections={corrections} setCorrections={setCorrections} handleCorrectionChange={handleCorrectionChange} changeModalOpen={changeModalOpen} mypageData={mypageData} sameAsExhibitor={sameAsExhibitor2} setSameAsExhibitor={setSameAsExhibitor2} fieldsDisabled={fieldsDisabled2} setFieldsDisabled={setFieldsDisabled2} sameAsCertExhibitor={sameAsCertExhibitor} setSameAsCertExhibitor={setSameAsCertExhibitor} fieldsCertDisabled={fieldsCertDisabled} setFieldsCertDisabled={setFieldsCertDisabled} sameAsCertExhibitor2={sameAsCertExhibitor2} setSameAsCertExhibitor2={setSameAsCertExhibitor2} fieldsCertDisabled2={fieldsCertDisabled2} setFieldsCertDisabled2={setFieldsCertDisabled2} submitErrors={submitErrors2} setSubmitErrors={setSubmitErrors2} isCorpModal={isCorpModal} detailErrors={detailErrors} setDetailErrors={setDetailErrors} otherMethod={otherMethod} handleOtherMethodChange={handleOtherMethodChange} handleMethodChange={handleMethodChange} />
            </Container>
            <div style={{padding: '15px'}}></div>
            <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
              <Typography className='info'>
                【上記入力内容についてのお問い合わせ先】<br />
                ビジネスフェア2026企画運営室（中部経済新聞社 事業部内）<br />
                担当：中島、佐野<br />
                TEL:052-561-5675<br />
                入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
                ※お急ぎの場合はお電話にてお問い合わせください。
              </Typography>
            </Box>
            {!isCorpModal &&(
            <Container sx={{textAlign: 'center'}}>
                <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                    提出する
                </Button>
            </Container>
            )}
            <Dialog
              open={downloadModalOpen}
              onClose={() => !downloadLoading && setDownloadModalOpen(false)}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>証票PDFのダウンロード</DialogTitle>
              <DialogContent>
                <Typography sx={{ mt: 1 }}>
                  保存が完了しました。搬入出車両証／館内乗入許可証のPDFを作成してダウンロードしますか。
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setDownloadModalOpen(false);
                    finalizeAfterSubmit();
                  }}
                  disabled={downloadLoading}
                >
                  あとで
                </Button>
                <Button onClick={handleDownloadCertificates} variant="contained" disabled={downloadLoading}>
                  {downloadLoading ? "PDF作成中..." : "ダウンロードする"}
                </Button>
              </DialogActions>
            </Dialog>
        </Container>
      </Container>
      {!isCorpModal &&(
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default FormRequire;
